import { createContext, useContext, useState } from "react"
import { otService } from "../services/otService"
import { useUtiles } from "./utilesContext"
import Swal from "sweetalert2"

const OtContext = createContext()

export const useOt = () => {
    return useContext(OtContext)
}

export const OtProvider = ({ children }) => {
    const [ot, setOt] = useState(null)
    const [loadingOt, setLoadingOt] = useState(false)
    const { setAlertSnackbar, toogleOpenSilder, resetOpenSilder } = useUtiles()

    //Obtener OT por hash
    const getOtByHash = async (hash) => {
        try {
            setLoadingOt(true)
            const response = await otService.getOtByHash(hash)
            setOt(response.data)
        } catch (error) {
            console.log('Error completo:', error);
            let errorMessage = 'Error al obtener la OT';
            
            if (error.response) {
                // Error de respuesta del servidor
                errorMessage = `Error OT BY HASH ${error.response.status}: ${JSON.stringify(error.response.data)}`;
                console.log('Error de respuesta:', {
                    status: error.response.status,
                    data: error.response.data,
                    headers: error.response.headers
                });
            } else if (error.request) {
                // Error de solicitud (no se recibió respuesta)
                errorMessage = `Error de conexión: ${error.request.status || 'No hay respuesta del servidor'}`;
                console.log('Error de solicitud:', error.request);
            } else {
                // Error de configuración
                errorMessage = `Error: ${error.message || 'Error desconocido'}`;
                console.log('Error de configuración:', error.message);
            }

            setAlertSnackbar({
                open: true,
                message: errorMessage,
                severity: 'error'
            })
        } finally {
            setLoadingOt(false)
        }
    }


    //Obtener OT calculada
    const [loadingOtCalculateCompleted, setLoadingOtCalculateCompleted] = useState(false)
    const [otCalculateCompleted, setOtCalculateCompleted] = useState(null)
    const getOtCalculateCompleted = async (hash) => {
        try {
            setLoadingOtCalculateCompleted(true)
            const response = await otService.getOtCalculateCompleted(hash)
            setOtCalculateCompleted(response.data)
        } catch (error) {
            console.log('Error completo:', error);
            let errorMessage = 'Error al obtener la OT';
            
            if (error.response) {
                // Error de respuesta del servidor
                errorMessage = `Error OT CALCULATE COMPLETED ${error.response.status}: ${JSON.stringify(error.response.data)}`;
                console.log('Error de respuesta:', {
                    status: error.response.status,
                    data: error.response.data,
                    headers: error.response.headers
                });
            } else if (error.request) {
                // Error de solicitud (no se recibió respuesta)
                errorMessage = `Error de conexión: ${error.request.status || 'No hay respuesta del servidor'}`;
                console.log('Error de solicitud:', error.request);
            } else {
                // Error de configuración
                errorMessage = `Error: ${error.message || 'Error desconocido'}`;
                console.log('Error de configuración:', error.message);
            }

            setAlertSnackbar({
                open: true,
                message: errorMessage,
                severity: 'error'
            })
        } finally {
            setLoadingOtCalculateCompleted(false)
        }
    }

    //Enviar OT a revisión
    const [loadingSendOtToReview, setLoadingSendOtToReview] = useState(false)
    const [otSelectToMove, setOtSelectToMove] = useState(null)
    const sendOtToReview = async (comment, status, callAllTasks = null) => {

        const VerboseStatus = status === 'review' ? '¿Estás seguro de querer enviar la OT a revisión?' : '¿Estás seguro de querer finalizar la OT?'

        const confirm = await Swal.fire({
            title: VerboseStatus,
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            customClass: {
                container: 'custom-swal2-container',
                popup: 'custom-swal2-popup',
                backdrop: 'custom-swal2-backdrop',
            }
        })
        if (!confirm.isConfirmed) {
            return 
        }
        try {
            setLoadingSendOtToReview(true)
            const data = {
                hash_code: otSelectToMove?.hash_code,
                comment: comment,
                status_type: status
            }
            const response = await otService.sendOTStatus(data)
            setLoadingSendOtToReview(false)
            setAlertSnackbar({
                open: true,
                message: response.data.message || 'OT enviada a revisión correctamente',
                severity: 'success'
            })
            await getOtByHash(otSelectToMove?.hash_code) 

            if (callAllTasks) {
                await callAllTasks()
            }

            toogleOpenSilder(null, 500, '')

        } catch (error) {
            console.log('Error completo:', error);
            let errorMessage = 'Error al enviar la OT a revisión';
            
            if (error.response) {
                // Error de respuesta del servidor
                errorMessage = `Error ${error.response.status}: ${JSON.stringify(error.response.data)}`;
                console.log('Error de respuesta:', {
                    status: error.response.status,
                    data: error.response.data,
                    headers: error.response.headers
                });
            } else if (error.request) {
                // Error de solicitud (no se recibió respuesta)
                errorMessage = `Error de conexión: ${error.request.status || 'No hay respuesta del servidor'}`;
                console.log('Error de solicitud:', error.request);
            } else {
                // Error de configuración
                errorMessage = `Error: ${error.message || 'Error desconocido'}`;
                console.log('Error de configuración:', error.message);
            }

            setLoadingSendOtToReview(false)
            setAlertSnackbar({
                open: true,
                message: errorMessage,
                severity: 'error'
            })
            
        }
    }

    //Obtener PDF de la OT
    const [loadingOtPdf, setLoadingOtPdf] = useState(false)
    const getOtPdf = async (hash) => {
        try {
            setLoadingOtPdf(true)
            const response = await otService.getOtPdf(hash)

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `OT.pdf`)
            document.body.appendChild(link)
            link.click()

            setAlertSnackbar({
                open: true,
                message: 'PDF generado correctamente',
                severity: 'success'
            })
        } catch (error) {
            console.error('Error al generar el PDF:', error)
          
            
            setAlertSnackbar({
                open: true,
                message: errorMessage,
                severity: 'error'
            })
        } finally {
            setLoadingOtPdf(false)
        }
    }

    //Obtener historial de la OT
    const [loadingOtHistory, setLoadingOtHistory] = useState(false)
    const [otHistory, setOtHistory] = useState([])
    const getOtHistory = async (hash) => {
        try {
            setLoadingOtHistory(true)
            const response = await otService.getOtHistory(hash)
            setOtHistory(response.data)
        } catch (error) {
            console.error('Error al obtener el historial de la OT:', error)
            setAlertSnackbar({
                open: true,
                message: 'Error al obtener el historial de la OT',
                severity: 'error'
            })
        } finally {
            setLoadingOtHistory(false)
        }
    }

    //Cambiar responsable de la OT
    const [loadingChangeAsignedOt, setLoadingChangeAsignedOt] = useState(false)
    const [otChangeAsignedOt, setOtChangeAsignedOt] = useState(null)
    const [otChangeExtraTech, setOtChangeExtraTech] = useState([])
    const changeAsignedOtAndExtraTech = async (data) => {
        try {
            setLoadingChangeAsignedOt(true)
            const dataToSend = {
                hash_code: ot.hash_code,
                ...data
            }
            const response = await otService.changeAsignedOt(dataToSend)
            setLoadingChangeAsignedOt(false)
            setAlertSnackbar({
                open: true,
                message: response.data.message || 'OT actualizada correctamente',
                severity: 'success'
            })
            await getOtByHash(ot.hash_code)
            resetOpenSilder()
        } catch (error) {
            console.error('Error al cambiar el responsable de la OT:', error)
            setAlertSnackbar({
                open: true,
                message: 'Error al cambiar el responsable de la OT',
                severity: 'error'
            })
        }
    }


    return <OtContext.Provider
        value={{ ot, setOt, 
        loadingOt, getOtByHash,
        otCalculateCompleted, setOtCalculateCompleted,
        loadingOtCalculateCompleted, getOtCalculateCompleted,
        loadingSendOtToReview, sendOtToReview,
        otSelectToMove, setOtSelectToMove,
        loadingOtPdf, getOtPdf,
        loadingOtHistory, getOtHistory,
        otHistory, setOtHistory,
        otChangeAsignedOt, setOtChangeAsignedOt,
        otChangeExtraTech, setOtChangeExtraTech,
        loadingChangeAsignedOt, changeAsignedOtAndExtraTech }}>
        {children}
    </OtContext.Provider>
}